module.exports = __webpack_public_path__ + "img/agent_no.9ebc8503.svg";